import { Http } from './http.init'
import { ResponseWrapper, ErrorWrapper } from './util'

const ENTITY = 'albums'

export function create (data) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).post(`${ENTITY}`, data)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function update (id, data) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).patch(`${ENTITY}/${id}`, data)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function getById (id) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).get(`${ENTITY}/${id}`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function remove (id) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).delete(`${ENTITY}/${id}`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function getLast () {
  return new Promise((resolve, reject) => {
    new Http().get(`${ENTITY}/last`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function getListPublic (parameters = {}) {
  const params = {
    ...parameters
  }
  return new Promise((resolve, reject) => {
    new Http().get(`${ENTITY}`, { params })
      .then(response => {
        let data = {
          content: response.data.data.results,
          total: response.data.data.total
        }
        resolve(new ResponseWrapper(response, data))
      }).catch(error => reject(new ErrorWrapper(error)))
  })
}

export function getList (parameters = {}) {
  const params = {
    ...parameters
  }
  return new Promise((resolve, reject) => {
    new Http({auth: true}).get(`${ENTITY}`, { params })
      .then(response => {
        let data = {
          content: response.data.data.results,
          total: response.data.data.total
        }
        resolve(new ResponseWrapper(response, data))
      }).catch(error => reject(new ErrorWrapper(error)))
  })
}

// PROGRESS BAR EXAMPLE
// export function uploadCoverIndexImage (id, data) {
//   const config = {
//     onUploadProgress (progressEvent) {
//       let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
//       console.log('onUploadProgress', percentCompleted)
//     }
//   }
//   return new Promise((resolve, reject) => {
//     new Http({auth: true}).post(`${ENTITY}/${id}/cover/index`, data, config)
//       .then(response => resolve(new ResponseWrapper(response, response.data.data)))
//       .catch(error => reject(new ErrorWrapper(error)))
//   })
// }

export function uploadCoverIndexImage (id, data) {
  const config = {
    onUploadProgress (progressEvent) {
      let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      console.log('onUploadProgress', percentCompleted)
    }
  }
  return new Promise((resolve, reject) => {
    new Http({auth: true}).post(`${ENTITY}/${id}/cover/index`, data, config)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function removeCoverIndexImage (id) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).delete(`${ENTITY}/${id}/cover/index`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function uploadCoverThumbnailImage (id, data) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).post(`${ENTITY}/${id}/cover/thumbnail`, data)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function removeCoverThumbnailImage (id) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).delete(`${ENTITY}/${id}/cover/thumbnail`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function uploadPhotoToAlbum (id, data) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).post(`${ENTITY}/${id}/upload`, data)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function attachTag (albumId, tagId) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).post(`${ENTITY}/${albumId}/attach-tag/${tagId}`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function detachTag (albumId, tagId) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).post(`${ENTITY}/${albumId}/detach-tag/${tagId}`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}



// WEBPACK FOOTER //
// ./src/services/albums.service.js